var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import OperationLine from './Model';
import { action, observable } from 'mobx';
import { api } from 'helpers/Api';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this.miniset = function (values) {
            _this.data = values.map(function (item) {
                var temp = __assign({}, item);
                return temp;
            });
            _this.loaded = true;
            return _this.data;
        };
        this.set = function (values) {
            _this.data = values.map(function (item) { return new OperationLine(item); });
            _this.loaded = true;
            return _this.data;
        };
        this.push = function (value) {
            _this.data.push(new OperationLine(value));
        };
        this.replace = function (value) {
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === value.id; }), 1, value);
        };
        this.pull = function (value) {
            _this.data.splice(_this.data.findIndex(function (a) { return a.id === value.id; }), 1);
        };
    }
    default_1.prototype.read = function (id) {
        var _this = this;
        // console.log('OperationLines/Store - read')
        var eager = '[businessUnit]';
        if (id)
            return api.get('operationlines/' + id + '?eager=' + eager);
        return api.get('operationlines' + '?eager=' + eager).then(function (value) {
            // console.log('operationLines', value)
            return _this.set(value);
            // return value
        });
    };
    default_1.prototype.readSelect = function (select) {
        /*return api.get(`stretches?select=id&select=name&select=operationLine_id`).then(result => {
          return this.set(result)
        })*/
        return api.get("operationlines?select=".concat(select)).then(this.miniset);
    };
    default_1.prototype.create = function (value) {
        return api.post('operationlines', value).then(this.push);
    };
    default_1.prototype.update = function (id, value) {
        return api.put('operationlines/' + id, value).then(this.replace);
    };
    default_1.prototype.disable = function (id, disabled) {
        return api.patch('operationlines/' + id, { disabled: disabled }).then(this.pull);
    };
    default_1.prototype.findOperationlineById = function (id) {
        // console.log('this.data: ', this.data)
        return this.data.filter(function (value) { return value.id === id; })[0];
    };
    __decorate([
        observable
    ], default_1.prototype, "data", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        action
    ], default_1.prototype, "miniset", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "push", void 0);
    __decorate([
        action
    ], default_1.prototype, "replace", void 0);
    __decorate([
        action
    ], default_1.prototype, "pull", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/OperationLines/Store.ts
// module id = 701
// module chunks = 0